import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ManufacturerImageStyles {
    wrapperImage?: InjectableCss;
    image?: LazyImageProps;
}

export const manufacturerImageStyles: ManufacturerImageStyles = {
    wrapperImage: {
        css: css`
            width: 100%;
            margin-top: 25px;
            text-align: center;
        `,
    },
    image: {
        css: css`
            img {
                width: auto;
                max-width: 140px;
                max-height: 75px;
            }
        `,
    },
};

const styles = manufacturerImageStyles;

const ManufacturerImage: React.FC<Props> = ({ product: { properties } }) => {
    if (!properties.manufacturerImageUrl) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapperImage}>
            <LazyImage
                {...styles.image}
                src={properties.manufacturerImageUrl}
                altText={translate("Manufacturer Logo")}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ManufacturerImage),
    definition: {
        displayName: "Store Manufacturer Image",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
